import { render, staticRenderFns } from "./global-search.vue?vue&type=template&id=1e211cb4&scoped=true&"
import script from "./global-search.vue?vue&type=script&lang=js&"
export * from "./global-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e211cb4",
  null
  
)

export default component.exports